import React, { Component } from 'react';
import { 
    TextField, 
    Grid, 
    Select, 
    InputLabel, 
    OutlinedInput, 
    FormControl, 
    Typography,
    Card,
    CardContent
} from '@mui/material';
import { Edit, Delete, FilterListRounded, CloseRounded, ArrowBackRounded } from '@mui/icons-material';

import { isEmpty } from "lodash";
import InputText, { InputSelect, InputSelectMulti, InputSelectNative } from '../common/Form';
import { sanitizeAmountInput } from '../../utils/searchFilters';
import { yearsList } from '../../utils/statsFunctions';
import { MONTHS } from '../../utils/generalFuncs';

class FilterSpendings extends Component {
    state = {  }
    render() {
        const { CATEGORIES, noPaymentFilter, USERS, SUPPLIERS, LABELS, PROJECTS} = this.props;
        return (
            // <Dialog
            //     disableBackdropClick
            //     open={true}
            //     onClose={this.props.handleClose}
            //     aria-labelledby="form-dialog-title"
            //     fullWidth
            //     maxWidth="md"
            // >
            //     <AppBar style={{position: 'relative'}} color="primary">
            //         <Toolbar>
            //             <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
            //                 <ArrowBackRounded />
            //             </IconButton>
            //             <Typography variant="h6" color="inherit">
            //                 Filtrer les dépenses
            //             </Typography>
            //         </Toolbar>
            //     </AppBar>
            //     <DialogContent>

            <Card style={{margin: "10px"}}>
                <CardContent>
                    <Typography gutterBottom>
                        Filtrer les Dépenses
                    </Typography>
                    <Grid container>
                        <Grid item xs={6}>
                            <InputSelectMulti
                                label="Mois"
                                name="searchMonth"
                                onChange={(option) => this.props.handleSelect(option, "searchMonth")}
                                value={this.props.searchMonth}
                                id="searchMonth"
                                options={MONTHS.map( (month, index) => ({
                                    label: month,
                                    value: index,
                                    disabled: Array.isArray(this.props.searchMonth) && !!this.props.searchMonth.find(element => element.value === index)
                                    
                                })) }
                                isMulti
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputSelectNative
                                label="Année"
                                name="searchYear"
                                onChange={this.props.handleChange}
                                value={this.props.searchYear}
                                labelWidth={70} 
                                id="searchYear"
                                options={yearsList().map( year => (
                                    <option value={year} key={year}>
                                        {year}
                                    </option>
                                )) }
                            />
                            {/* <InputSelectMulti
                                label="Année"
                                name="searchYear"
                                onChange={(option) => this.props.handleSelect(option, "searchYear")}
                                value={this.props.searchYear}
                                labelWidth={70} 
                                id="searchYear"
                                options={yearsList().map( year => (
                                    <option value={year} key={year}>
                                        {year}
                                    </option>
                                )) }
                            /> */}
                        </Grid>
                        <Grid item xs={12} sm={!noPaymentFilter ? 6 : 12}>
                            <InputSelectNative
                                label="Statut Dépense"
                                name="spend_status"
                                onChange={this.props.handleChange}
                                value={this.props.spend_status}
                                labelWidth={120} 
                                name="spend_status" 
                                id="spend_status" 
                                options={[
                                    <option value="WAITING_VALIDATION" >En Attente</option>,
                                    <option value="WAITING_UPDATE" >À Corriger</option>,
                                    <option value="VALIDATE" >Validé</option>,
                                    <option value="REFUSED" >Refusé</option>,
                                ]}
                            />
                        </Grid>
                        {!noPaymentFilter &&
                            <Grid item xs={12} sm={6}>
                                <InputSelectNative
                                    label="Statut Paiement"
                                    name="pay_status"
                                    onChange={this.props.handleChange}
                                    value={this.props.pay_status}
                                    labelWidth={120} 
                                    name="pay_status" 
                                    id="pay_status" 
                                    options={[
                                        // <option value="all" ></option>,
                                        <option value="payed" >Payés</option>,
                                        <option value="not_payed" >Non Payés</option>,
                                    ]}
                                />
                            </Grid>
                        }
                        {!isEmpty(CATEGORIES.LIST) && !isEmpty(CATEGORIES.PARENT) && 
                            <Grid item xs={12} sm={this.props.searchCategory.value ? 6 : 12}>
                                <InputSelect
                                    label="Catégorie"
                                    name="searchCategory"
                                    onChange={(option) => this.props.handleChangeMulti(option, "searchCategory")}
                                    value={this.props.searchCategory}
                                    name="searchCategory" 
                                    id="searchCategory" 
                                    // options={ Object.keys(CATEGORIES.PARENT).map( ID => (
                                    //     <option value={ID} key={ID}>
                                    //         {CATEGORIES.NAMES[ID].category_name}
                                    //     </option>
                                    // )) }
                                    options={[
                                        {value:"", label:"Toutes les catégories"},
                                        {value:"__NO_CATEGORY__", label:"Sans catégorie"},
                                        ...Object.values(CATEGORIES.PARENT).filter(c => c.is_active !== false).map( item => ({
                                            label: item.category_accounting_id ? `${item.category_accounting_id} - ${item.category_name}` : item.category_name,
                                            value: item.category_id,
                                            disabled: Array.isArray(this.props.searchCategory) && !!this.props.searchCategory.find(element => element.value === item.category_id)
                                        }))
                                    ]}
                                />
                            </Grid>
                        }
                        {!isEmpty(CATEGORIES.LIST) && !isEmpty(CATEGORIES.LIST[this.props.searchCategory.value]) && this.props.searchCategory &&
                            <Grid item xs={12} sm={6} >
                                <InputSelectNative
                                    label="Sous Catégorie"
                                    name="searchSubCategory"
                                    labelWidth={120}
                                    onChange={this.props.handleChange}
                                    value={this.props.searchSubCategory}
                                    name="searchSubCategory"
                                    options={ Object.values(CATEGORIES.LIST[this.props.searchCategory.value]).filter(ID => CATEGORIES.CHILD[ID] && CATEGORIES.CHILD[ID].is_active !== false).map( ID  => {
                                        const cat = CATEGORIES.CHILD[ID];
                                        return (
                                        <option value={ID} key={ID}>
                                            {cat.category_accounting_id ? `${cat.category_accounting_id} - ${cat.category_name}` : cat.category_name}
                                        </option>
                                    ); }) }
                                />
                            </Grid>
                        }
                        {!isEmpty(CATEGORIES.LIST) && !isEmpty(CATEGORIES.LIST[this.props.searchSubCategory]) && this.props.searchSubCategory &&
                            <Grid item xs={12} sm={6} >
                                <InputSelectNative
                                    label="Sous Catégorie 2"
                                    name="searchSubCategory2"
                                    labelWidth={120}
                                    onChange={this.props.handleChange}
                                    value={this.props.searchSubCategory2}
                                    name="searchSubCategory2"
                                    options={ Object.values(CATEGORIES.LIST[this.props.searchSubCategory]).filter(ID => CATEGORIES.CHILD[ID] && CATEGORIES.CHILD[ID].is_active !== false).map( ID  => {
                                        const cat = CATEGORIES.CHILD[ID];
                                        return (
                                        <option value={ID} key={ID}>
                                            {cat.category_accounting_id ? `${cat.category_accounting_id} - ${cat.category_name}` : cat.category_name}
                                        </option>
                                    ); }) }
                                />
                            </Grid>
                        }
                        {this.props.admin && !isEmpty(LABELS) &&
                        <Grid item xs={12} sm={6}>
                             <InputSelectMulti
                                label="Labels"
                                id="searchLabel"
                                options={Object.values(LABELS).map( item => ({
                                    label: `${item.label_name}`,
                                    value: item.label_id,
                                    disabled: Array.isArray(this.props.searchLabel) && !!this.props.searchLabel.find(element => element.value === item.label_id)
                                }))}
                                value={this.props.searchLabel}
                                onChange={(option) => this.props.handleChangeMulti(option, "searchLabel")}
                                isMulti
                            />
                        </Grid>
                        }
                        {this.props.admin && !isEmpty(PROJECTS) &&
                        <Grid item xs={12} sm={6}>
                             <InputSelectMulti
                                label="Projets"
                                id="searchProject"
                                options={Object.values(PROJECTS).map( item => ({
                                    label: `${item.project_name}`,
                                    value: item.project_id,
                                    disabled: Array.isArray(this.props.searchProject) && !!this.props.searchProject.find(element => element.value === item.project_id)
                                }))}
                                value={this.props.searchProject}
                                onChange={(option) => this.props.handleChangeMulti(option, "searchProject")}
                                isMulti
                            />
                        </Grid>
                        }
                        {this.props.admin && !isEmpty(SUPPLIERS) &&
                        <Grid item xs={12} sm={6}>
                            {/* <InputText
                                // style={{width:"100%"}}
                                onChange={this.props.handleChange}
                                // margin="normal"
                                // variant="outlined"  
                                name="searchSupplier" 
                                id="searchSupplier" 
                                value={this.props.searchSupplier} 
                                label="Fournisseurs" 
                                placeholder="Fournisseur1, Fournisseur2, ..."
                            /> */}
                            <InputSelectMulti
                                label="Fournisseurs"
                                id="searchSupplier"
                                options={Object.values(SUPPLIERS).map( item => ({
                                    label: `${item.supplier_name}`,
                                    value: item.supplier_id,
                                    disabled: Array.isArray(this.props.searchSupplier) && !!this.props.searchSupplier.find(element => element.value === item.supplier_id)
                                }))}
                                value={this.props.searchSupplier}
                                onChange={(option) => this.props.handleChangeMulti(option, "searchSupplier")}
                                isMulti
                            />
                        </Grid>
                        }
                        {this.props.admin && !isEmpty(USERS) &&
                        // <Grid item xs={12} sm={6} >
                        //     <InputSelectNative
                        //         label="Utilisateur"
                        //         name="searchUser"
                        //         onChange={this.props.handleChange}
                        //         value={this.props.searchUser}
                        //         labelWidth={80} 
                        //         options={ !isEmpty(USERS) && Object.values(USERS).map( user  => (
                        //             <option value={user.user_id} key={user.user_id}>
                        //                 {`${user.username ? `${user.username} ${user.lastname}` : user.email}`}
                        //             </option>
                        //         )) }
                        //         />
                        // </Grid>

                        <Grid item xs={6}>
                            <InputSelectMulti
                                label="Utilisateur"
                                id="searchUser"
                                options={Object.values(USERS).map( item => ({
                                    label: `${item.email} - ${item.lastname.toUpperCase()} ${item.username}`,
                                    value: item.user_id,
                                    disabled: Array.isArray(this.props.searchUser) && !!this.props.searchUser.find(element => element.value === item.user_id)
                                }))}
                                value={this.props.searchUser}
                                onChange={(option) => this.props.handleChangeMulti(option, "searchUser")}
                                isMulti
                            />
                        </Grid>
                        }
                        {this.props.admin &&
                        <Grid item xs={12} sm={6}>
                            <InputText
                                // style={{width:"100%"}}
                                onChange={this.props.handleChange}
                                // margin="normal"
                                // variant="outlined"  
                                name="searchFacture" 
                                id="searchFacture" 
                                value={this.props.searchFacture} 
                                label="Facture" 
                            />
                            
                        </Grid>
                        }
                        
                        {this.props.withSearchFilters && (
                            <Grid item xs={12}><Grid container>
                                <Grid item xs={12} sm={6} style={{padding: 9}}>
                                    <TextField
                                        label="Description"
                                        name="searchDesc"
                                        value={this.props.searchDesc || ""}
                                        onChange={this.props.handleChange}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3} style={{padding: 9}}>
                                    <TextField
                                        label="Montant min"
                                        name="amountMin"
                                        value={this.props.amountMin || ""}
                                        onChange={(e) => { e.target.value = sanitizeAmountInput(e.target.value); this.props.handleChange(e); }}
                                        inputProps={{ inputMode: "decimal" }}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3} style={{padding: 9}}>
                                    <TextField
                                        label="Montant max"
                                        name="amountMax"
                                        value={this.props.amountMax || ""}
                                        onChange={(e) => { e.target.value = sanitizeAmountInput(e.target.value); this.props.handleChange(e); }}
                                        inputProps={{ inputMode: "decimal" }}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid></Grid>
                        )}
                    </Grid>
                </CardContent>
            </Card>
            //     </DialogContent>
            // </Dialog>
        );
    }
}

export default FilterSpendings;

// {openFilters && 
//     <Dialog
//         disableBackdropClick
//         open={openFilters}
//         onClose={() => this.setState({ openFilters: false })}
//         aria-labelledby="form-dialog-title"
//         fullWidth
//         maxWidth="md"
//     >
//     <AppBar style={{position: 'relative'}} color="primary">
//         <Toolbar>
//             <IconButton color="inherit" onClick={() => this.setState({ openFilters: false })} aria-label="Close">
//                 <ArrowBackRounded />
//             </IconButton>
//             <Typography variant="h6" color="inherit">
//                 Filtrer les dépenses
//             </Typography>
//         </Toolbar>
//     </AppBar>
//     <DialogContent>

//         <Grid container spacing={2}>
//             {!isEmpty(CATEGORIES.ALL) && !isEmpty(CATEGORIES.PARENT) && 
//                 <Grid item xs={12} sm={6} >
//                     <FormControl variant="outlined" style={{width: "100%"}}>
//                         <InputLabel htmlFor="searchCategory">Catégorie</InputLabel>
//                         <Select
//                             native
//                             onChange={(e) => this.setState({[e.target.name]: e.target.value, searchSubCategory: ""})}
//                             value={this.state.searchCategory}
//                             input={<OutlinedInput labelWidth={80} name="searchCategory" id="searchCategory" />}
                            
//                         >
//                             <option value="" />
//                             { Object.keys(CATEGORIES.ALL).map( ID => (
//                                 <option value={ID} key={ID}>
//                                     {CATEGORIES.PARENT[ID].category_name}
//                                 </option>
//                             )) }
//                         </Select>
//                     </FormControl>
//                 </Grid>
//             }
//             {!isEmpty(CATEGORIES.ALL) && !isEmpty(CATEGORIES.ALL[this.state.searchCategory]) && this.state.searchCategory &&
//                 <Grid item xs={12} sm={6} >
//                     <FormControl variant="outlined" style={{width: "100%"}}>
//                         <InputLabel htmlFor="searchSubCategory">Sous Catégorie</InputLabel>
//                         <Select
//                             native
//                             onChange={(e) => this.setState({[e.target.name]: e.target.value})}
//                             value={this.state.searchSubCategory}
//                             input={<OutlinedInput labelWidth={120} name="searchSubCategory" id="searchSubCategory" />}
//                         >
//                             <option value="" />
//                             { Object.values(CATEGORIES.ALL[this.state.searchCategory]).map( ID  => (
//                                 <option value={ID} key={ID}>
//                                     {CATEGORIES.CHILD[ID].category_name}
//                                 </option>
//                             )) }
//                         </Select>
//                     </FormControl>
//                 </Grid>
//             }
//             <Grid item xs={12}>
//             {this.props.admin &&
//                 <TextField
//                     style={{width:"100%"}}
//                     onChange={(e) => this.setState({[e.target.name]: e.target.value})}
//                     // margin="normal"
//                     variant="outlined"  
//                     name="searchBar" 
//                     id="searchBar" 
//                     value={this.state.searchBar} 
//                     label="Labels" 
//                     placeholder="Label1, Label2, ..."
//                 />
                
//             }
//             </Grid>
            
//         </Grid>
//     </DialogContent>
//     </Dialog>
//     }